import type { SVGProps } from "react";
const SvgArrowUp02Sharp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M10 4.167v12.5M5.833 7.5l3.578-3.577c.278-.278.416-.417.589-.417s.312.139.59.417L14.166 7.5"
    />
  </svg>
);
export default SvgArrowUp02Sharp;
